export function emptyEvent() {
  return {
    title: '',
    startDate: new Date(),
    endDate: new Date(),
  };
}
